import { render, staticRenderFns } from "./LeadersTableManagement.vue?vue&type=template&id=23966048&scoped=true"
import script from "./LeadersTableManagement.vue?vue&type=script&lang=js"
export * from "./LeadersTableManagement.vue?vue&type=script&lang=js"
import style0 from "./LeadersTableManagement.css?vue&type=style&index=0&id=23966048&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23966048",
  null
  
)

export default component.exports